import InfoBlock from './InfoBlock'
import SideDrawer from './SideDrawer'
export { InfoBlock }
export default SideDrawer
export type { ISideDrawer } from './SideDrawer.types'
